export default [
  {
    label: 'sendAmazon',
    module: {
      type: 'marketplace',
      identifier: 'amazon'
    },
    value: 'marketplace/amazon/provide'
  },
  {
    label: 'sendCarrefour',
    module: {
      type: 'marketplace',
      identifier: 'carrefour'
    },
    value: 'marketplace/carrefour/provide'
  },
  {
    label: 'sendCentauro',
    module: {
      type: 'marketplace',
      identifier: 'centauro'
    },
    value: 'marketplace/centauro/provide'
  },
  {
    label: 'sendCnova',
    module: {
      type: 'marketplace',
      identifier: 'cnova'
    },
    value: 'marketplace/cnova/provide'
  },
  {
    label: 'sendColombo',
    module: {
      type: 'marketplace',
      identifier: 'colombo'
    },
    value: 'marketplace/colombo/provide'
  },
  {
    label: 'sendConectaLa',
    module: {
      type: 'marketplace',
      identifier: 'conectaLa'
    },
    value: 'marketplace/conectaLa/provide'
  },
  {
    label: 'sendGfg',
    module: {
      type: 'marketplace',
      identifier: 'gfg'
    },
    value: 'marketplace/gfg/provide'
  },
  {
    label: 'sendIntegracommerce',
    module: {
      type: 'marketplace',
      identifier: 'integracommerce'
    },
    value: 'marketplace/integracommerce/provide'
  },
  {
    label: 'sendLeroy',
    module: {
      type: 'marketplace',
      identifier: 'leroy'
    },
    value: 'marketplace/leroy/provide'
  },
  {
    label: 'sendMadeira',
    module: {
      type: 'marketplace',
      identifier: 'madeira'
    },
    value: 'marketplace/madeira/provide'
  },
  {
    label: 'sendMagalu',
    module: {
      type: 'marketplace',
      identifier: 'magalu'
    },
    value: 'marketplace/magalu/provide'
  },
  {
    label: 'sendMercadoLivre',
    module: {
      type: 'marketplace',
      identifier: 'mercadoLivre'
    },
    value: 'marketplace/mercadoLivre/announcement'
  },
  {
    label: 'sendNetshoes',
    module: {
      type: 'marketplace',
      identifier: 'netshoes'
    },
    value: 'marketplace/netshoes/provide'
  },
  {
    label: 'sendPolishop',
    module: {
      type: 'marketplace',
      identifier: 'polishop'
    },
    value: 'marketplace/polishop/provide'
  },
  {
    label: 'sendSicoob',
    module: {
      type: 'marketplace',
      identifier: 'sicoob'
    },
    value: 'marketplace/sicoob/provide'
  },
  {
    label: 'sendPrivalia',
    module: {
      type: 'marketplace',
      identifier: 'privalia'
    },
    value: 'marketplace/privalia/provide'
  },
  {
    label: 'sendDecathlon',
    module: {
      type: 'marketplace',
      identifier: 'decathlon'
    },
    value: 'marketplace/decathlon/provide'
  },
  {
    label: 'sendKeepRunning',
    module: {
      type: 'marketplace',
      identifier: 'keepRunning'
    },
    value: 'marketplace/keepRunning/provide'
  },
  {
    label: 'sendRamarim',
    module: {
      type: 'marketplace',
      identifier: 'ramarim'
    },
    value: 'marketplace/ramarim/provide'
  },
  {
    label: 'sendComfortflex',
    module: {
      type: 'marketplace',
      identifier: 'comfortflex'
    },
    value: 'marketplace/comfortflex/provide'
  },
  {
    label: 'sendSicredi',
    module: {
      type: 'marketplace',
      identifier: 'sicredi'
    },
    value: 'marketplace/sicredi/provide'
  },
  {
    label: 'sendMaisCorreios',
    module: {
      type: 'marketplace',
      identifier: 'maisCorreios'
    },
    value: 'marketplace/maisCorreios/provide'
  },
  {
    label: 'sendWebcontinental',
    module: {
      type: 'marketplace',
      identifier: 'webcontinental'
    },
    value: 'marketplace/webcontinental/provide'
  },
  {
    label: 'sendRenner',
    module: {
      type: 'marketplace',
      identifier: 'renner'
    },
    value: 'marketplace/renner/provide'
  },
  {
    label: 'sendRicardoEletro',
    module: {
      type: 'marketplace',
      identifier: 'ricardoEletro'
    },
    value: 'marketplace/ricardoEletro/provide'
  },
  {
    label: 'sendShopee',
    module: {
      type: 'marketplace',
      identifier: 'shopee'
    },
    value: 'marketplace/shopee/provide'
  },
  {
    label: 'sendSkyhub',
    module: {
      type: 'marketplace',
      identifier: 'skyhub'
    },
    value: 'marketplace/skyhub/provide'
  },
  {
    label: 'sendWalmart',
    module: {
      type: 'marketplace',
      identifier: 'walmart'
    },
    value: 'marketplace/walmart/provide'
  },
  {
    label: 'sendZoom',
    module: {
      type: 'marketplace',
      identifier: 'zoom'
    },
    value: 'marketplace/zoom/provide'
  },
  {
    label: 'sendTikTokShop',
    module: {
      type: 'marketplace',
      identifier: 'tikTokShop'
    },
    value: 'marketplace/tikTokShop/provide'
  },
  {
    label: 'sendShein',
    module: {
      type: 'marketplace',
      identifier: 'shein'
    },
    value: 'marketplace/shein/provide'
  }
]



// WEBPACK FOOTER //
// ./src/storage/bulkActions.js